import {Component, HostBinding, Injector, Input} from '@angular/core'
import {ControlValueAccessorConnectorDirective} from '../control-value-accessor-connector.directive'
import {NG_VALUE_ACCESSOR} from '@angular/forms'
import {Observable} from 'rxjs'
import {isControlInvalid} from '../form.types'

export interface SelectItem {
  key: string
  valueTranslationKey?: string
  value?: string | number
}

@Component({
  selector: 'cft-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class SelectComponent extends ControlValueAccessorConnectorDirective {
  @Input() items: SelectItem[] = []
  @Input() id?: string
  @Input() label?: string
  @Input() loading$?: Observable<boolean>
  @HostBinding('class.multi-select') @Input() multiSelect = false

  constructor(injector: Injector) {
    super(injector)
  }

  get controlId(): string | undefined {
    return this.id ?? this.controlName
  }

  protected readonly isControlInvalid = isControlInvalid

  selectMultiple(e: MouseEvent, item: string) {
    e.preventDefault()
    e.stopPropagation()

    const options: string[] = this.control?.value ?? []
    const index = options.indexOf(item)
    if (index > -1) {
      options.splice(index, 1)
      this.control?.setValue(options)
    } else {
      this.control?.setValue([...options, item])
    }
  }
}
